import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Typography,
  Button,
  Chip,
  Stack,
  Divider,
  Box,
  IconButton,
  Paper,
  Skeleton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptIcon from "@mui/icons-material/Receipt";
import noDataFolder from "../../Assets/folder.png";

// 100% MUI Version — NO other libraries
// SimulationCard (MUI Only)

export default function SimulationCard(props) {
  let { adminLoading, adminIndividualData } = props;

  console.log(adminIndividualData, "adminIndividualData");

  const institutionData = Array.isArray(adminIndividualData)
    ? adminIndividualData.flatMap((item) => item?.simulations || [])
    : [];

  console.log(institutionData, "institutionData");
  const SimulationData = [
    {
      name: "Simulation Name",
      allottedMembers: 50,
      status: "Active",
      paymentHistory: [],
      invoiceUrl: null,
      id: 1,
      updatedAt: "—",
      totalPaid: 0,
    },
    {
      name: "Sample Simulation",
      allottedMembers: 40,
      status: "Pending",
      paymentHistory: [],
      invoiceUrl: null,
      id: 2,
      updatedAt: "—",
      totalPaid: 0,
    },
  ];

  const statusColor = (status) =>
    ({
      Active: "success",
      Pending: "warning",
      Completed: "info",
      Draft: "default",
    })[status];

  return (
    <Paper sx={{ p: 3 }}>
      {adminLoading ? (
        <InstitutionCardSkeleton />
      ) : !institutionData.length ? (
        <>
          <Card
            variant="outlined"
            sx={{
              borderRadius: 3,
              p: 1,
              boxShadow: "0px 3px 10px #eee",
              mb: 3,
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                p: 15,
                minHeight: "45vh",
              }}
            >
              <img
                src={noDataFolder}
                height={"100px"}
                width={"100px"}
                alt="img"
              />
              <Typography>No simulations found</Typography>
            </Box>
          </Card>
        </>
      ) : (
        institutionData?.map((value, index) => (
          <Card
            key={index}
            variant="outlined"
            sx={{
              borderRadius: 3,
              p: 1,
              boxShadow: "0px 3px 10px #eee",
              mb: 3,
            }}
          >
            <CardHeader
              title={
                <Typography variant="h6">
                  {value?.simulation_name ?? "-"}
                </Typography>
              }
              subheader={
                <Typography variant="caption" color="text.secondary">
                  Simulation Code: {value?.simulation_code}
                </Typography>
              }
              action={
                <IconButton>
                  <MoreVertIcon />
                </IconButton>
              }
            />

            <CardContent>
              <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                <Chip
                  label={value?.status}
                  color={statusColor(value?.status)}
                  size="small"
                />
                {/* <Typography variant="body2" color="text.secondary">
                  {institutionData?.[0]?.members_count ?? "0"} member
                  {institutionData?.[0]?.members_count === 1 ? "" : "s"}{" "}
                  allotted{" "}
                </Typography>{" "}
                <Divider orientation="vertical" variant="middle" flexItem /> */}
                <Typography variant="body2" color="text.secondary">
                  {value?.members} Member
                  {value?.members === 1 ? "" : "s"} Assigned &nbsp;&nbsp; |
                  &nbsp;&nbsp;&nbsp;{" "}
                  {adminIndividualData[0]?.institutions[0]?.members_count ?? ""}{" "}
                  Members Allotted
                </Typography>
              </Stack>

              {/* Payment History */}
              <Box mb={2}>
                <Typography variant="subtitle2" color="text.secondary" mb={1}>
                  Payment History
                </Typography>
                {/* {value.paymentHistory.length > 0 ? (
                <Stack spacing={0.5}>
                  {value.paymentHistory.slice(0, 3).map((p, idx) => (
                    <Stack
                      key={idx}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Typography variant="body2">{p.title}</Typography>
                      <Typography variant="body2" fontWeight={600}>
                        {p.amount}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              ) : ( */}
                <Typography variant="body2" color="text.disabled">
                  No payments yet
                </Typography>
                {/* )} */}
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography variant="subtitle2" color="text.secondary" mb={1}>
                Invoice
              </Typography>
              <Stack direction={"column"}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<ReceiptIcon />}
                  sx={{ mb: 1 }}
                >
                  View Invoice
                </Button>

                <Stack direction="row" spacing={1}>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={<EditIcon />}
                    // color="#0b2b1c"
                    sx={{
                      background: "#71926E",
                      ":hover": { background: "#71926E", color: "white" },
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      background: "#F7A000",
                      ":hover": { background: "#F7A000", color: "white" },
                    }}
                  >
                    Remove
                  </Button>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      background: "#914F4E",
                      ":hover": { background: "#914F4E", color: "white" },
                    }}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </Button>
                </Stack>
              </Stack>
            </CardContent>

            <CardActions sx={{ justifyContent: "space-between" }}>
              <Typography variant="caption" color="text.secondary">
                Last updated: {value.updatedAt ?? "-"}
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="caption">Total Paid:</Typography>
                <Typography variant="caption" fontWeight={600}>
                  {value.totalPaid ?? "-"}
                </Typography>
              </Stack>
            </CardActions>
          </Card>
        ))
      )}
    </Paper>
  );
}

const InstitutionCardSkeleton = () => {
  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: 3, p: 1, boxShadow: "0px 3px 10px #eee", mb: 3 }}
    >
      {/* Header */}
      <CardHeader
        avatar={<Skeleton variant="circular" width={40} height={40} />}
        title={<Skeleton variant="text" width="60%" height={28} />}
        subheader={<Skeleton variant="text" width="40%" height={20} />}
        action={<Skeleton variant="circular" width={30} height={30} />}
      />

      <CardContent>
        {/* Status + members */}
        <Stack direction="row" spacing={2} alignItems="center" mb={2}>
          <Skeleton variant="rounded" width={70} height={28} />
          <Skeleton variant="text" width={120} height={20} />
        </Stack>

        {/* Payment History Title */}
        <Skeleton variant="text" width={120} height={22} />

        {/* Placeholder rows */}
        <Stack spacing={1} mt={1} mb={2}>
          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="75%" height={20} />
          <Skeleton variant="text" width="60%" height={20} />
        </Stack>

        <Divider sx={{ my: 2 }} />

        {/* Invoice section */}
        <Skeleton variant="text" width={80} height={22} />

        <Stack direction="column" mt={1}>
          <Skeleton variant="rounded" height={40} sx={{ mb: 1 }} />

          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
            <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
            <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
          </Stack>
        </Stack>
      </CardContent>

      <CardActions sx={{ justifyContent: "space-between" }}>
        <Skeleton variant="text" width={120} height={18} />
        <Skeleton variant="text" width={80} height={18} />
      </CardActions>
    </Card>
  );
};
